var map = {
	"./cs/main2.yml": 73,
	"./da/main2.yml": 74,
	"./de/main2.yml": 75,
	"./en/main2.yml": 76,
	"./eo/main2.yml": 77,
	"./es/main2.yml": 78,
	"./fr/main2.yml": 79,
	"./gd/main2.yml": 80,
	"./id/main2.yml": 81,
	"./it/main2.yml": 82,
	"./pl/main2.yml": 83,
	"./ru/main2.yml": 84,
	"./si/main2.yml": 85,
	"./tr/main2.yml": 86
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 206;